import { z } from 'zod';
export const placeSuggestionSchema = z.object({
    placeId: z.string(),
    description: z.string(),
});
export const placeAddressSchema = z.object({
    long_name: z.string(),
    short_name: z.string(),
    types: z.array(z.string()),
});
